import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "iFart is making me want an iPhone",
  "description": "",
  "published": "2008-12-17T00:00:00.000Z",
  "redirect_from": ["/blog/ifart-is-making-me-want-an-iphone/swizec/29"],
  "categories": "funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I came across `}<a parentName="p" {...{
        "href": "http://ifartmobile.com/"
      }}>{`iFart`}</a>{` on twitter via `}<a parentName="p" {...{
        "href": "http://twitter.com/styletime"
      }}>{`@styletime`}</a>{` and it's made me want an iPhone. Let's set aside the fact I've wanted one for a while because any reason I wanted it wasn't nearly as cool as this nor as big of an incentive to spend too much money on a telephone.`}</p>
    <p>{`But iFart changed things. It is a perfectly admirable piece of technology that enables your telephone to fart whenever you want. You can make iFart fart right away or perhaps you want to do it with a timer - this could be used to time tea brewing in a somewhat disgusting manner. And the piece de la resistance - security iFart! Just set your iPhone down somewhere, leave it alone, and the moment somebody moves it the damn thing starts farting at full blast, leaving you with an easy way to catch somebody red handed with their fat sticky fingers all over that shiny touch-screen of yours.`}</p>
    <p>{`Let the video tell you more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      